import { render } from "./practiceCreate.vue?vue&type=template&id=a56a056a"
import script from "./practiceCreate.vue?vue&type=script&lang=js"
export * from "./practiceCreate.vue?vue&type=script&lang=js"

import "./practiceCreate.vue?vue&type=style&index=0&id=a56a056a&lang=css"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__